import React from "react";
import commonStyles from "../../../styles/common.module.css";
import { useTranslation } from "react-i18next";

const ErrorTable = ({ description }: { description: string }) => {
  const parsedData = JSON.parse(description);
  const {t} = useTranslation();
  function getErrorTableHeader(title: string) {
    switch (title) {
      case "ocrConfidenceErrors":
        return t('primarydocument.errortable.header2');
      case "mrzConsistencyErrors":
        return t('primarydocument.errortable.header3');
      case "tamperedErrors":
        return t('primarydocument.errortable.header1');
      case "barcodeConsistencyErrors":
        return t('primarydocument.errortable.header4');
      // Not a list of faults: the documents this issuer does accept, sent with an
      // acceptance rejection so the applicant knows what to fetch instead.
      case "acceptedDocuments":
        return t('primarydocument.errortable.header5');
      default:
        return t(title);
    }
  }

  const unpackedLowConfidenceValues: Record<string, string> = {
    address: t("primarydocument.ocr.address"),
    dateofissue: t("primarydocument.ocr.dateofissue"),
    dateofbirth: t("primarydocument.ocr.dateofbirth"),
    dob: t("primarydocument.ocr.dateofbirth"),
    documentnumber: t("primarydocument.ocr.documentnumber"),
    dateofexpiry: t("primarydocument.ocr.dateofexpiry"),
    givennames: t("primarydocument.ocr.givennames"),
    firstname: t("primarydocument.ocr.firstname"),
    lastname: t("primarydocument.ocr.lastname"),
    name: t("primarydocument.ocr.name"),
    sex: t("primarydocument.ocr.sex"),
    country: t("primarydocument.ocr.country"),
    surname: t("primarydocument.ocr.surname"),
  };

  return (
    <div className={commonStyles.errorTable}>
      {Object.entries(parsedData).map(([key, values]) => (
        <div className={commonStyles.errorFieldsContainer} key={key}>
          {(values as string[])?.length > 0 && (
            <div className={commonStyles.errorFieldContainer}>
              <div className={commonStyles.errorFieldNameContainer}>
                {getErrorTableHeader(key)}
              </div>
              <div key={key} className={commonStyles.errorFieldValueContainer}>
                <ul>
                  {(values as string[]).map((value, index) => {
                    const label = value
                      .split(", ")
                      .map((part) => {
                        const key = part.trim().toLowerCase();
                        return (unpackedLowConfidenceValues[key] ?? part);
                      })
                      .join(", ");

                    return (
                      <li
                        key={index}
                        style={{
                          paddingLeft: "0px",
                          marginLeft: "0px",
                          textAlign: "left",
                        }}
                      >
                        {
                        key === "tamperedErrors"
                        ? t(value).charAt(0).toUpperCase() + t(value).slice(1)
                        : label}
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default ErrorTable;
